// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isSubset(subset: any, obj: any): boolean {
  return Object.keys(subset).every((key) => {
    if (typeof subset[key] === 'object' && subset[key] !== null && obj[key]) {
      return isSubset(subset[key], obj[key]);
    } else {
      return obj[key] === subset[key];
    }
  });
}
